import { store } from 'stores/store';
import axios from 'axios';

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
	timeout: 30000,
});

axiosInstance.interceptors.request.use(
	(config) => {
		const state = store.getState();
		const token = state.auth.token;

		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		config.headers['Content-Type'] = 'application/json';

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default axiosInstance;
